/* eslint-disable eqeqeq */
import React from 'react'

import * as f from '../../components/BPMTable/BPMInputs'
import { 
    DataMapper, 
    DataTransformer, 
    NullClickStrategy, 
    OnlyFilterActionDisplayStrategy, 
    TableFieldDescription, 
    DateComponentCreator,
    DateDisplayCreator,
} from '../../components/BPMTable/TableMapperCreator'
import {GraphQLDownloadFile} from "../../components/FileDownloader/FileComponentDownloader"
import {ExportFooterItemCreator} from "../../components/BPMTable/TableFooterItems"
import TableCreatorCreator from '../../components/BPMTable/TableCreatorFactory/TableCreatorCreator'
import tableCreatorCreatorFactoryCreator from '../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator'
import {DirectTableQueryBuilder} from "../../components/BPMTable/TableQueryBuilder/DirectTableQueryBuilder";


const queries = {tableQueryBuilder: new DirectTableQueryBuilder('lossDeviceReport')};

class LossReportTableCreator extends TableCreatorCreator {
    constructor(filters) {
        super(filters)
    }

    static getId = () => {
        return "LossReportTableCreator"
    }

    getTableCreator = (tableName) => {
        const tableCreator =  this.createTableCreator(this.constructor.getId(), tableName, queries, new NullClickStrategy(), new OnlyFilterActionDisplayStrategy())
        tableCreator.setAdditionalFilters({first: 30})
        tableCreator.setInitialSortField('date', 'desc')
        tableCreator.setTableFooterItems([new ExportFooterItemCreator()]);

        tableCreator.setDescriptions([
            new TableFieldDescription(
                'serialNumber',
                new DataMapper("deviceLoss.device.serialNumber"),
                new f.FilterDescription(new f.TextFilter("serialNumber")),
                {label: 'Serial Number'}
            ),
            new TableFieldDescription(
                'type',
                new DataMapper("deviceLoss.type.name"),
                new f.FilterDescription(new f.TextFilter("type")),
                {label: 'Type'}
            ),
            new TableFieldDescription(
                'date',
                new DataMapper("deviceLoss.date"),
                new f.FilterDescription(new f.DateFilter("date")),
                {label: 'Date', componentCreator: new DateComponentCreator(), excelDisplay: new DateDisplayCreator()}
            ),
            new TableFieldDescription(
                'firstName',
                new DataMapper("user.firstName"),
                new f.FilterDescription(new f.TextFilter("firstName")),
                {label: 'User Name'}
            ),
            new TableFieldDescription(
                'userId',
                new DataMapper("user.enterpriseId"),
                new f.FilterDescription(new f.TextFilter("userId")),
                {label: 'User ID'}
            ),
            new TableFieldDescription(
                'lastName',
                new DataMapper("user.lastName"),
                new f.FilterDescription(new f.TextFilter("lastName")),
                {label: 'User Surname'}
            ),
            new TableFieldDescription(
                'managerId',
                new DataMapper("user.manager.enterpriseId"),
                new f.FilterDescription(new f.TextFilter("managerId")),
                {label: 'Manager Id'}
            ),
            new TableFieldDescription(
                'managerFirstName',
                new DataMapper("user.manager.firstName"),
                new f.FilterDescription(new f.TextFilter("managerFirstName")),
                {label: 'Manager Name'}
            ),
            new TableFieldDescription(
                'managerLastName',
                new DataMapper("user.manager.lastName"),
                new f.FilterDescription(new f.TextFilter("managerLastName")),
                {label: 'Manager Surname'}
            ),
            new TableFieldDescription(
                'model',
                new DataMapper("deviceLoss.device.model.name"),
                new f.FilterDescription(new f.TextFilter("model")),
                {label: 'Model'}
            ),
            new TableFieldDescription(
                'brand',
                new DataMapper("deviceLoss.device.model.brand.name"),
                new f.FilterDescription(new f.TextFilter("brand")),
                {label: 'Brand'}
            ),
            new TableFieldDescription(
                'serialNumberType',
                new DataMapper("deviceLoss.device.serialNumberType.name"),
                new f.FilterDescription(new f.TextFilter("serialNumberType")),
                {label: 'Serial Number Type'}
            ),
            new TableFieldDescription(
                'downloadFile',
                new DataMapper("deviceLoss"),
                new f.FilterDescription(new f.NullCreator()),
                // eslint-disable-next-line eqeqeq
                {label: 'Loss File', hideSort:true, transform: new DataTransformer(({deviceLoss}) => deviceLoss.file ? <GraphQLDownloadFile resourceType='device_loss' id={deviceLoss.id} /> : null)}
            ),
        ])

        return tableCreator;
    }
}

tableCreatorCreatorFactoryCreator.addTableCreatorCreator(LossReportTableCreator)

export default LossReportTableCreator;
